// src/hooks/usePreloader.js
import { useEffect } from "react";

export const usePreloader = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      const preloader = document.querySelector(".preloader");
      if (preloader) {
        preloader.remove();
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, []);
};
